import TokenFactories from "../../models/factories/token-factories";
import Assert from "tbAssert";

const mImplicitSearchConnectorOpName = new WeakMap();
const mOpTokenFactorySvc = new WeakMap();
const mLogSvc = new WeakMap();

class ImplicitSearchConnectorTokenFactory {
    constructor($log, OpTokenFactory, connectorOpName) {
        Assert.StrictAssert(($log != null), "Assertion Failure: Missing Log Service Dependency");
        mLogSvc.set(this, $log);

        Assert.StrictAssert((OpTokenFactory != null), "Assertion Failure: Missing Op Token Factory Service Dependency");
        mOpTokenFactorySvc.set(this, OpTokenFactory);

        if (angular.isString(connectorOpName)) {
            mImplicitSearchConnectorOpName.set(this,connectorOpName);
        }
        else {
            throw new Error("Invalid or missing connector op name for implicit search connector");
        }
    }

    get ConnectorOpName() {
        return mImplicitSearchConnectorOpName.get(this);
    }

    set ConnectorOpName(opName) {
        if (angular.isString(opName)) {
            mImplicitSearchConnectorOpName.set(this, opName);
        }
        else {
            throw new Error("Implict Search Connector: Connector Type Name Must Be A String.");
        }
    }

    getConnectorToken() {
        if (mImplicitSearchConnectorOpName.get(this) == null) { //If either the value is null or there is no value for 'this' in the WeakMap.
            throw new Error("Implicit Search Connector Service Not Initialized");
        }

        let connectorToken = mOpTokenFactorySvc.get(this).buildToken(mImplicitSearchConnectorOpName.get(this));
        mLogSvc.get(this).debug(`Built Implicit Connector Token: ${connectorToken.toString()}`);
        return connectorToken;
    }

    toString() {
        return "ImplicitSearchConnectorTokenFactory";
    }

    static Create($log, OpTokenFactory) {
        return ((connectorOpName) => new ImplicitSearchConnectorTokenFactory($log, OpTokenFactory, connectorOpName));
    }
}

ImplicitSearchConnectorTokenFactory.Create.$inject = [ "$log", "OpTokenFactory" ];

export default angular
    .module("trackerbase-app.services.search-request-parser.implicit-search-connector-factory",[
        TokenFactories
    ])
    .factory("ImplicitSearchConnectorTokenFactory", ImplicitSearchConnectorTokenFactory.Create)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/search-request-parser/ImplicitSearchConnectorTokenFactory.js
// module id = STga
// module chunks = 1